/**
 * Function to download a file from a given link with a specified filename
 * @param link {string} Relative link to the file
 * @param filename {string} Name of the file to be downloaded
 * @returns {void}
 */
export const downloadFile = (link: string, filename: string): void => {
  try {
    // Construct the full URL for the file
    const viewUrl = `${window.location.origin}${link}`;

    const downloadLink = document.createElement('a');
    downloadLink.href = viewUrl;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    
  } catch (error) {
    console.error('Failed to download specifications:', error);
  }
};